import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { Policy } from '@wsphere/warranties/domain';
import { PolicyService } from '../../services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-copy-policy-to-environment-dialog',
  templateUrl: './copy-policy-to-environment.dialog.html',
  standalone: false,
})
export class CopyPolicyToEnvironmentDialog {
  constructor(
    private policySvc: PolicyService,
    private toastSvc: ToastService
  ) {}

  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Input() policy?: Policy.Model | null;
  /** The environment the app is currently running in, which is the source of the copy */
  @Input() isSandbox = false;

  saving = false;

  get source() {
    return this.isSandbox ? 'SANDBOX' : 'LIVE';
  }

  get target() {
    return this.isSandbox ? 'LIVE' : 'SANDBOX';
  }

  open() {
    this.dialog.open();
  }

  close() {
    this.dialog.close();
  }

  async copy() {
    if (!this.policy) throw new Error('Unable to copy policy, policy not found');

    this.saving = true;

    const response = await (
      this.isSandbox ? this.policySvc.migrateToLive(this.policy.id) : this.policySvc.migrateToSandbox(this.policy.id)
    ).catch(({ error }) => {
      this.toastSvc.show({ type: 'error', title: 'Copy failed', text: error.message });
    });

    this.saving = false;

    if (response?.id) {
      this.toastSvc.show({
        type: 'success',
        title: 'Policy copied successfully',
        text: `<strong>${this.policy.title}</strong> has been copied to ${this.target} as a new draft policy.`,
      });
      this.close();
    }
  }
}
